import Button from "react-bootstrap/Button";

function LinkButton({ text, onClick }) {
  return (
    <>
      <style type="text/css">
        {`
          .btn-secondary {
            color: #0900CB;
            background-color: white;
            padding: 12px 20px;
            font-size: 16px;
            border: 1px solid var(--gradient-brand-80060045-deg, #070097);            
            border-radius: 6px;
            font-size: 16px;
            font-weight: 500;
            box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
          }
          .btn-secondary:hover {
            background: linear-gradient(45deg, #070097 0%, #211AFB 100%);
            color: white;
            transform: none;          }

           @media (max-width: 480px) {
            .btn-secondary {
              width: 100%;
      }
    }

        `}
      </style>

      <Button variant="secondary" onClick={onClick}>
        {text}
      </Button>
    </>
  );
}

export default LinkButton;
